import { createPageUrl } from '@/utils';

export function getNotificationRoute(notification = {}) {
  const explicitRoute = String(notification.route || '').trim();
  if (explicitRoute) return explicitRoute;

  const type = String(notification.type || '').trim();
  const referenceId = String(notification.reference_id || notification.referenceId || '').trim();

  switch (type) {
    case 'message':
      return createPageUrl('Mensagens');
    case 'event':
      return referenceId ? `${createPageUrl('Agenda')}?eventId=${referenceId}` : createPageUrl('Agenda');
    case 'worship_schedule':
    case 'worship_schedule_reminder_day_before':
    case 'worship_schedule_reminder_12h':
      return referenceId ? `${createPageUrl('EscalasLouvor')}?scheduleId=${referenceId}` : createPageUrl('EscalasLouvor');
    case 'media_schedule':
    case 'media_schedule_reminder_day_before':
    case 'media_schedule_reminder_12h':
      return referenceId ? `${createPageUrl('EscalasMidia')}?scheduleId=${referenceId}` : createPageUrl('EscalasMidia');
    case 'dance_schedule':
    case 'dance_schedule_reminder_day_before':
    case 'dance_schedule_reminder_12h':
      return referenceId ? `${createPageUrl('EscalasDanca')}?scheduleId=${referenceId}` : createPageUrl('EscalasDanca');
    case 'kids_schedule':
    case 'kids_schedule_reminder_day_before':
    case 'kids_schedule_reminder_12h':
      return referenceId ? `${createPageUrl('EscalasKidsMBV')}?scheduleId=${referenceId}` : createPageUrl('EscalasKidsMBV');
    case 'reception_schedule':
    case 'reception_schedule_reminder_day_before':
    case 'reception_schedule_reminder_12h':
      return referenceId ? `${createPageUrl('EscalasRecepcao')}?scheduleId=${referenceId}` : createPageUrl('EscalasRecepcao');
    case 'availability_reminder_weekly':
    case 'availability_reminder_monthly':
      return createPageUrl('CalendarioDisponibilidade');
    case 'member_card_request':
      return createPageUrl('AdminMembros');
    case 'member_signup_request':
      return createPageUrl('AdminMembros');
    case 'prayer_request':
      return createPageUrl('AdminOracoes');
    case 'general':
      return createPageUrl('Grupos');
    default:
      return createPageUrl('Home');
  }
}

export function navigateFromNotification(navigate, notification = {}) {
  if (typeof navigate !== 'function') return;
  const route = getNotificationRoute(notification);
  if (route) navigate(route);
}
